import Patient from "./patient/repository";
import Data from './data/repository'
import {instance as DataSource, onlineDataSource} from "./DataSource";
import LocalStorage from "./localStorage";


const repositories = {
    patient: new Patient(DataSource),
    patientOnline: new Patient(onlineDataSource),
    data: new Data(DataSource),
    dataOnline: new Data(onlineDataSource),
    localStorage: new LocalStorage(),
};

export default {get: (name) => repositories[name]};
